// src/components/finance/steps/PANStep.jsx
import React, { useState } from 'react';
import '../../../styles/LoanSteps.css';

const PANStep = ({ data, onNext, loading, onAuthRequired }) => {
  const [pan, setPan]     = useState(data.pan || '');
  const [error, setError] = useState('');

  const validatePAN = (value) => {
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    return panRegex.test(value);
  };

  const handleChange = (e) => {
    const val = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
    setPan(val);
    setError('');
  };

  const isTokenMissingError = (err) => {
    const msg = (
      err?.response?.data?.error ||
      err?.response?.data?.message ||
      err?.message ||
      ''
    ).toLowerCase();
    return (
      msg.includes('token') ||
      msg.includes('unauthorized') ||
      msg.includes('not authenticated') ||
      msg.includes('jwt') ||
      err?.response?.status === 401 ||
      err?.response?.status === 403
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validatePAN(pan)) {
      setError('Please enter a valid PAN number (e.g. ABCDE1234F)');
      return;
    }
    try {
      await onNext({ pan });
    } catch (err) {
      if (isTokenMissingError(err)) {
        // Silently redirect to login — no error shown to user
        if (onAuthRequired) {
          onAuthRequired();
        }
        return;
      }
      setError(err?.response?.data?.error || 'Something went wrong. Please try again.');
    }
  };

  const isValid = validatePAN(pan);

  return (
    <div className="step-container">
      <div className="step-header">
        <h3>PAN number</h3>
        <p>Enter the PAN linked with your mobile number</p>
      </div>
      <form onSubmit={handleSubmit} className="step-form">
        <div className="form-group">
          <label>PAN</label>
          <input
            type="text"
            value={pan}
            onChange={handleChange}
            placeholder="ABCDE1234F"
            maxLength={10}
            className={error ? 'error' : ''}
            autoFocus
            autoCapitalize="characters"
            style={{
              letterSpacing: pan ? '3px' : '0',
              fontWeight: pan ? '600' : '400',
              textTransform: 'uppercase',
            }}
          />
          {error && <span className="error-text">{error}</span>}
          {!error && pan.length > 0 && pan.length < 10 && (
            <span style={{ fontSize: '0.8rem', color: '#6B7280', marginTop: '4px', display: 'block' }}>
              {10 - pan.length} more character{10 - pan.length !== 1 ? 's' : ''} needed
            </span>
          )}
          {isValid && (
            <span style={{ fontSize: '0.82rem', color: '#10B981', marginTop: '4px', fontWeight: 600, display: 'block' }}>
              ✓ Valid PAN format
            </span>
          )}
        </div>
        <button
          type="submit"
          className="next-button"
          disabled={loading || !pan || pan.length < 10}
        >
          {loading ? 'Processing...' : 'Next'}
        </button>
      </form>
    </div>
  );
};

export default PANStep;